export default {
    activateText: '松开立即刷新',
    deactivateText: '下拉可以刷新',
    finishText: '完成刷新'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/pull-to-refresh/locale/zh_CN.js
// module id = 1902
// module chunks = 0